import { Helmet } from "react-helmet";

function Description({ title, description }) {
  return (
    <div className="flex gap-1">
      <p className="text-gold">
        {title}
        <span className="text-black-100"> {description}</span>
      </p>
    </div>
  );
}

function DescriptionList({ items = [] }) {
  return (
    <ul className="list-none p-0 text-start">
      {items.map(({ title, description }, i) => (
        <li key={i}>
          <Description title={title} description={description} />
        </li>
      ))}
    </ul>
  );
}

export default function DrivesScore() {
  const keyAttributes = [
    {
      title: "Real-Time Updates:",
      description:
        "Scores adjust instantly after every significant moment—each play, pitch, or shot.",
    },
    {
      title: "Intuitive Clarity:",
      description:
        "Directly reflects changes in scoring likelihood, easily understood by fans and broadcasters alike.",
    },
    {
      title: "Continuous Engagement:",
      description:
        "Enables live, interactive betting markets and fan participation opportunities.",
    },
    {
      title: "Insightful Analytics:",
      description:
        'Converts traditionally subjective concepts—circumstances, play value, and event significance—into measurable insights, uniquely calculating real-time situational value and clearly distinguishing meaningful plays from "garbage" ones.',
    },
  ];

  const drivesScoreMatters = [
    {
      title: "Drives Score Matters Across Sports:",
      description:
        "Enhanced Fan Experience: Transforms passive viewing into active participation, deepening fan connection and understanding.",
    },
    {
      title: "Unified Approach:",
      description:
        "Provides a consistent scoring framework applicable to football, baseball, golf, and beyond, ensuring familiarity and ease of use across sports.",
    },
    {
      title: "Data-Driven Commentary:",
      description:
        "Gives broadcasters real-time, measurable insights to enrich narratives, highlight pivotal moments, and enhance storytelling.",
    },
  ];

  return (
    <section className="section about-section">
      <Helmet>
        <title>Drives Score</title>
      </Helmet>

      <div className="flex flex-col items-center container mx-auto gap-0">
        <div className="flex flex-col items-center gap-0">
          <p className="mx-auto mt-6">
            Real-Time Sports Analytics — The{" "}
            <strong className="text-white">Drives Score</strong>
            <sup
              className="text-white"
              style={{
                paddingLeft: "1px",
                fontSize: "0.6em",
                fontWeight: "bold",
                verticalAlign: "super",
              }}
            >
              TM
            </sup>{" "}
            quantifies the expected scoring outcome of each key segment within a
            sporting event, dynamically updating after every meaningful action.
            Originally developed for football, this innovative approach
            naturally extends across multiple sports—transforming the way fans,
            broadcasters, and bettors experience live events.
          </p>
        </div>

        <div>
          <h2 className="text-2xl text-gold mb-5 pt-0 mt-0 text-center">
            Key Attributes
          </h2>
          <DescriptionList items={keyAttributes} />
        </div>

        <div>
          <h2 className="text-2xl text-gold mb-5 text-center pt-0 mt-2">
            Drives Score Matters Across Sports{" "}
          </h2>
          <DescriptionList items={drivesScoreMatters} />
        </div>
      </div>
      {/* <AdvancedStats /> */}
    </section>
  );
}
